var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 16.7617C11.3055 16.7617 10.7385 17.3267 10.7385 18.0227C10.7385 18.7177 11.3055 19.2827 12.0005 19.2827C12.6955 19.2827 13.2615 18.7177 13.2615 18.0227C13.2615 17.3267 12.6955 16.7617 12.0005 16.7617Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 10.7402C11.3055 10.7402 10.7385 11.3052 10.7385 12.0012C10.7385 12.6962 11.3055 13.2612 12.0005 13.2612C12.6955 13.2612 13.2615 12.6962 13.2615 12.0012C13.2615 11.3052 12.6955 10.7402 12.0005 10.7402Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 7.23975C12.6955 7.23975 13.2615 6.67475 13.2615 5.97875C13.2615 5.28375 12.6955 4.71875 12.0005 4.71875C11.3055 4.71875 10.7385 5.28375 10.7385 5.97875C10.7385 6.67475 11.3055 7.23975 12.0005 7.23975Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/vertical-dots.132cc05e9afc857316cb73b7367a1c9e.svg";
export { ForwardRef as ReactComponent };